
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { ACTIONS } from '@/constants/actions';
import { GETTERS } from '@/constants/getters';
import { APP_VUEX_MODULES } from '@/constants/vuex-modules';
import { AppPossibleLanguages } from '@/enums/app-possible-languages.enum';
import { getAppLayoutDirectionByLanguage } from '@/utils/app-language.util';

export default Vue.extend({
  name: 'LanguageMenu',
  props: {
    color: {
      type: String,
      default: 'white'
    }
  },
  computed: {
    ...mapGetters(APP_VUEX_MODULES.ui, {
      currentLanguage: GETTERS.ui.language,
      languageName: GETTERS.ui.languageName,
      availableLanguages: GETTERS.ui.availableLanguages
    })
  },
  methods: {
    changeLanguage(language: AppPossibleLanguages): void {
      const { dispatch } = this.$store;
      dispatch(ACTIONS.ui.changeAppLanguage, { language }).then(
        (language: AppPossibleLanguages) => {
          this.$vuetify.rtl = getAppLayoutDirectionByLanguage(language) === 'rtl';
          this.$i18n.locale = language;
          this.$emit('languageChanged', language);
        }
      );
    }
  }
});
